import { ROLE_DESCRIPTION } from 'utils/constants'

export const SUPER_ADMIN_LABEL = 'Super Admin'

export const ROLE_LABELS = {
  owner: 'Admin',
  agent: 'User',
  responsible_person: 'Responsible person',
  principal_accountable_person: 'Principal accountable person',
  principal_designer: 'Principal designer',
  prospective_purchaser: 'Prospective purchaser',
}

export const UNIT_ROLE_LABELS = {
  owner: 'Owner',
  agent: 'Agent',
  occupant: 'Occupant',
}

const humanise = value => (value ? String(value).replace(/_/g, ' ').replace(/^./, c => c.toUpperCase()) : '')

export const buildingRoleLabel = value => ROLE_LABELS[value] || humanise(value)

export const unitRoleLabel = value => UNIT_ROLE_LABELS[value] || humanise(value)

export const UNIT_ROLE_DESCRIPTIONS = {
  owner: 'Owner refers to the freeholder or long leaseholder of the property. If this is under corporate ownership, a contact person must be identified.',
  agent: '"Agents" include any person working on behalf of, or representing, the owner/landlord or another agent of the building. This includes architects, developers, surveyors, contractors, engineers etc.',
}

export const unitRoleDescription = value => UNIT_ROLE_DESCRIPTIONS[value] || ROLE_DESCRIPTION[value] || ''

export const ROLE_EXPLANATIONS = [
  { key: 'super_admin', label: SUPER_ADMIN_LABEL, text: 'Set for your whole organisation. Can do everything an Admin can on the organisation\'s buildings they have access to, and decides who can open the organisation\'s documents.' },
  { key: 'owner', label: 'Admin', text: 'Full control of this building: can see every document, change details, and add or remove people.' },
  { key: 'agent', label: 'User', text: 'Works on this building: can upload and update documents and tasks, but cannot see documents that have not been shared with them.' },
]
